/* Valyou instant search — UI layer. Owns the overlay, chips, facets and results.
   Depends on valyou-search.js (window.ValyouSearch). */
(function () {
  'use strict';
  var VS = window.ValyouSearch;
  if (!VS || window.__valyouSearchUI) return;
  window.__valyouSearchUI = true;

  var CDN = '//valyouhawaii.com/cdn/shop/files/';
  var GRID_W = [200, 300, 400, 600];
  var root = null, input = null, resEl = null, railEl = null, undEl = null, timer = null;

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
    return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  // index stores integer cents
  function money(c) {
    var n = Number(c) / 100;
    return '$' + n.toLocaleString('en-US', { minimumFractionDigits: n % 1 ? 2 : 0,
                                             maximumFractionDigits: n % 1 ? 2 : 0 });
  }
  function img(name, w) {
    if (!name) return '';
    var p = name.split('?');
    return CDN + p[0] + '?' + (p[1] ? p[1] + '&' : '') + 'width=' + w;
  }
  function sset(name) { return GRID_W.map(function (w) { return img(name, w) + ' ' + w + 'w'; }).join(', '); }
  function hex2rgb(h) { return [1, 3, 5].map(function (i) { return parseInt(h.slice(i, i + 2), 16); }); }
  function dist(a, b) { return Math.sqrt(Math.pow(a[0]-b[0],2) + Math.pow(a[1]-b[1],2) + Math.pow(a[2]-b[2],2)); }
  function kidx(list, k) { for (var i = 0; i < list.length; i++) if (list[i][0] === k) return i; return -1; }

  /* ---------- shell ---------- */
  function build() {
    if (root) return;
    root = document.createElement('div');
    root.className = 'vs-overlay';
    root.setAttribute('hidden', '');
    root.innerHTML =
      '<div class="vs-scrim" data-vs-close></div>' +
      '<div class="vs-panel" role="dialog" aria-modal="true" aria-label="Search Valyou">' +
        '<div class="vs-bar">' +
          '<svg class="vs-ic" viewBox="0 0 24 24" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/></svg>' +
          '<label class="vs-sr" for="vs-q">Search products</label>' +
          '<input id="vs-q" type="search" autocomplete="off" spellcheck="false" ' +
            'placeholder="Try &ldquo;grey sectional under $2,000&rdquo;">' +
          '<button class="vs-clear" data-vs-clear hidden>Clear</button>' +
          '<button class="vs-close" data-vs-close aria-label="Close search">Close</button>' +
        '</div>' +
        '<div class="vs-und" data-vs-und hidden></div>' +
        '<p class="vs-sr" role="status" aria-live="polite" aria-atomic="true" data-vs-status></p>' +
        '<div class="vs-body"><aside class="vs-rail" data-vs-rail hidden></aside>' +
        '<main class="vs-res" data-vs-res></main></div>' +
      '</div>';
    document.body.appendChild(root);
    input = root.querySelector('#vs-q');
    resEl = root.querySelector('[data-vs-res]');
    railEl = root.querySelector('[data-vs-rail]');
    undEl = root.querySelector('[data-vs-und]');

    input.addEventListener('input', function () {
      var a = VS.active; a.color = a.type = a.room = a.material = a.feature = null;
      clearTimeout(timer); timer = setTimeout(run, 90);
    });
    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-vs-close]')) return close();
      var c = e.target.closest('[data-vs-clear]');
      if (c) { input.value = ''; resetFacets(); run(); input.focus(); return; }
      var q = e.target.closest('[data-vs-q]');
      if (q) { input.value = q.getAttribute('data-vs-q'); resetFacets(); run(); input.focus(); return; }
      var pick = e.target.closest('[data-vs-pick]');
      if (pick) {
        // the blocking colour word must leave the query too, or search() short-circuits
        // on f.unstocked again and the button appears to do nothing
        var f0 = VS.parse(input.value);
        if (f0.unstocked.length) {
          var v = input.value;
          f0.unstocked.forEach(function (w) {
            v = v.replace(new RegExp('\\b' + w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '\\b', 'ig'), ' ');
          });
          input.value = v.replace(/\s+/g, ' ').trim();
        }
        resetFacets(); VS.active.color = pick.getAttribute('data-vs-pick'); run(); return;
      }
      var fc = e.target.closest('[data-vs-f]');
      if (fc) { var k = fc.getAttribute('data-vs-f'), v = fc.getAttribute('data-vs-v');
                VS.active[k] = VS.active[k] === v ? null : v; run(); return; }
      var ch = e.target.closest('[data-vs-unchip]');
      if (ch) { stripWord(ch.getAttribute('data-vs-unchip')); return; }
    });
    // colour-dot preview
    root.addEventListener('mouseover', function (e) {
      var d = e.target.closest('[data-vs-swap]');
      if (!d) return;
      var card = d.closest('.vs-card'), im = card && card.querySelector('img');
      if (!im) return;
      if (!im.dataset.orig) { im.dataset.orig = im.getAttribute('srcset') || ''; im.dataset.origSrc = im.src; }
      var name = d.getAttribute('data-vs-swap');
      if (name) { im.setAttribute('srcset', sset(name)); im.src = img(name, 400); }
    });
    root.addEventListener('mouseout', function (e) {
      var d = e.target.closest('[data-vs-swap]');
      if (!d) return;
      var card = d.closest('.vs-card'), im = card && card.querySelector('img');
      if (im && im.dataset.orig !== undefined) { im.setAttribute('srcset', im.dataset.orig); im.src = im.dataset.origSrc; }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !root.hasAttribute('hidden')) close();
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k') { e.preventDefault(); open(); }
    });
    // Enter inside the overlay input: the theme has a global handler that hijacks Enter on
    // search inputs and navigates to "//" (the home page). Own the key so that cannot happen.
    // Results are already live, so Enter commits the search and moves focus into the grid.
    input.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter') return;
      e.preventDefault();
      e.stopPropagation();
      var first = resEl.querySelector('.vs-card');
      if (first) { first.focus(); say('Showing results. Use Tab to browse them.'); }
      else {
        var q = encodeURIComponent(input.value || '');
        if (q) location.href = '/search?q=' + q;     // nothing here — hand over to Shopify
      }
    }, true);
  }
  // #10 focus containment: aria-modal alone does not stop Tab reaching the frozen page
  var inerted = [];
  function setInert(on) {
    if (on) {
      inerted = [];
      Array.prototype.forEach.call(document.body.children, function (el) {
        if (el === root || el.hasAttribute('inert')) return;
        el.setAttribute('inert', '');
        el.setAttribute('data-vs-inert', '');
        inerted.push(el);
      });
    } else {
      inerted.forEach(function (el) { el.removeAttribute('inert'); el.removeAttribute('data-vs-inert'); });
      inerted = [];
    }
  }

  function resetFacets() { var a = VS.active; a.color = a.type = a.room = a.material = a.feature = null; }

  function stripWord(bucketKey) {
    var parts = bucketKey.split('|'), bucket = parts[0], key = parts[1];
    if (VS.active[bucket]) { VS.active[bucket] = null; run(); return; }
    var BUCKET = { type: 'types', color: 'colors', room: 'rooms', material: 'mats', feature: 'feats' };
    var words = VS.index.words.filter(function (r) {
      return r[1] === BUCKET[bucket] && r[2] === key;
    }).map(function (r) { return r[0]; }).sort(function (a, b) { return b.length - a.length; });
    var v = input.value;
    words.forEach(function (w) {
      v = v.replace(new RegExp('\\b' + w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '\\b', 'ig'), ' ');
    });
    input.value = v.replace(/\s+/g, ' ').trim();
    run();
  }

  /* ---------- pieces ---------- */
  function chip(kind, label, hex, unchip) {
    return '<span class="vs-chip">' + (hex ? '<i style="background:' + hex + '"></i>' : '') +
      (kind ? '<span class="vs-k">' + esc(kind) + '</span>' : '') + esc(label) +
      (unchip ? '<button data-vs-unchip="' + esc(unchip) + '" aria-label="Remove ' + esc(label) + '">&times;</button>' : '') +
      '</span>';
  }
  function card(p, wantColors) {
    var I = VS.index;
    // Searching a colour should show that colourway, not the default featured shot.
    var hero = p.img, wanted = (wantColors || []).slice();
    if (VS.active.color && wanted.indexOf(VS.active.color) === -1) wanted.push(VS.active.color);
    if (wanted.length && p.ci) {
      for (var wi = 0; wi < p.c.length; wi++) {
        if (wanted.indexOf(I.colors[p.c[wi]][0]) > -1 && p.ci[wi]) { hero = p.ci[wi]; break; }
      }
    }
    var dots = p.c.slice(0, 6).map(function (ci, n) {
      var c = I.colors[ci], swap = p.ci && p.ci[n] ? p.ci[n] : '';
      return '<i style="background:' + c[2] + '"' + (swap ? ' data-vs-swap="' + esc(swap) + '"' : '') +
        (wantColors && wantColors.indexOf(c[0]) > -1 ? ' data-hit' : '') +
        ' title="' + esc(c[1]) + '"></i>';
    }).join('');
    var more = p.c.length > 6 ? '<u>+' + (p.c.length - 6) + '</u>' : '';
    var onSale = p.f.indexOf(kidx(I.feats, 'sale')) > -1;
    var badge = !p.buyable ? '<span class="vs-badge vs-badge--out">Sold out</span>'
              : p.pre ? '<span class="vs-badge">Pre-order</span>'
              : (onSale ? '<span class="vs-badge vs-badge--sale">Sale</span>' : '');
    var ty = p.ty >= 0 ? I.types[p.ty][1].replace(/s$/, '') : '';
    var rate = p.rt ? '<span class="vs-stars" aria-label="' + (p.rt / 10) + ' out of 5">' +
        '★★★★★'.slice(0, Math.round(p.rt / 10)) + '</span><span>' + (p.nr || '') + '</span>' : '';
    return '<a class="vs-card" href="/products/' + esc(p.h) + '">' +
      '<div class="vs-thumb">' + badge +
        '<img src="' + img(hero, 400) + '" srcset="' + sset(hero) + '" ' +
        'sizes="(min-width:1000px) 22vw, 45vw" loading="lazy" decoding="async" width="400" height="400" alt="' + esc(p.t) + '">' +
      '</div>' +
      '<div class="vs-t">' + esc(p.t) + '</div>' +
      '<div class="vs-m">' + (ty ? esc(ty) : '') + rate + '</div>' +
      (p.c.length ? '<div class="vs-dots">' + dots + more + '</div>' : '') +
      '<div class="vs-p">' + (p.min ? (p.min === p.max ? money(p.min) : 'From ' + money(p.min)) : '') + '</div>' +
      '</a>';
  }
  function understanding(f) {
    var I = VS.index, bits = [];
    f.types.forEach(function (k) { bits.push(chip('Type', I.types[kidx(I.types, k)][1], null, 'type|' + k)); });
    f.colors.forEach(function (k) { var c = I.colors[kidx(I.colors, k)]; bits.push(chip('Colour', c[1], c[2], 'color|' + k)); });
    f.unstocked.forEach(function (w) {
      var row = I.unstocked.filter(function (r) { return r[0] === w; })[0];
      bits.push(chip('Colour', w.charAt(0).toUpperCase() + w.slice(1), row ? row[1] : null, null)); });
    f.mats.forEach(function (k) { bits.push(chip('Material', I.mats[kidx(I.mats, k)][1], null, 'material|' + k)); });
    f.rooms.forEach(function (k) { bits.push(chip('Room', I.rooms[kidx(I.rooms, k)][1], null, 'room|' + k)); });
    f.feats.forEach(function (k) { bits.push(chip('', I.feats[kidx(I.feats, k)][1], null, 'feature|' + k)); });
    if (f.seats != null) bits.push(chip('Seats', f.seats + '+', null, null));
    if (f.max != null && f.min != null) bits.push(chip('Budget', '$' + f.min.toLocaleString('en-US') + '–$' + f.max.toLocaleString('en-US'), null, null));
    else if (f.max != null) bits.push(chip('Budget', 'Under $' + f.max.toLocaleString('en-US'), null, null));
    else if (f.min != null) bits.push(chip('Budget', 'Over $' + f.min.toLocaleString('en-US'), null, null));
    f.rest.forEach(function (t) { bits.push(chip('Text', t, null, null)); });
    undEl.hidden = !bits.length;
    undEl.innerHTML = bits.length ? '<span class="vs-lead">Understood</span>' + bits.join('') : '';
  }
  function rail(hits) {
    var I = VS.index;
    if (!hits.length) { railEl.hidden = true; root.querySelector('.vs-body').classList.add('vs-norail'); return; }
    railEl.hidden = false; root.querySelector('.vs-body').classList.remove('vs-norail');
    function sec(title, rows) { return rows.length > 1 ? '<section><h3>' + title + '</h3>' + rows.join('') + '</section>' : ''; }
    function countArr(key, i) { return hits.filter(function (p) { return p[key].indexOf(i) > -1; }).length; }
    var cols = I.colors.map(function (c, i) { return [c, countArr('c', i)]; })
      .filter(function (x) { return x[1]; }).sort(function (a, b) { return b[1] - a[1]; }).slice(0, 10)
      .map(function (x) { return '<button class="vs-facet" data-vs-f="color" data-vs-v="' + x[0][0] + '" aria-pressed="' +
        (VS.active.color === x[0][0]) + '"><i style="background:' + x[0][2] + '"></i>' + esc(x[0][1]) + '<u>' + x[1] + '</u></button>'; });
    var tys = I.types.map(function (t, i) { return [t, hits.filter(function (p) { return p.ty === i; }).length]; })
      .filter(function (x) { return x[1]; }).sort(function (a, b) { return b[1] - a[1]; }).slice(0, 9)
      .map(function (x) { return '<button class="vs-facet" data-vs-f="type" data-vs-v="' + x[0][0] + '" aria-pressed="' +
        (VS.active.type === x[0][0]) + '">' + esc(x[0][1]) + '<u>' + x[1] + '</u></button>'; });
    var rms = I.rooms.map(function (r, i) { return [r, countArr('r', i)]; })
      .filter(function (x) { return x[1]; }).sort(function (a, b) { return b[1] - a[1]; })
      .map(function (x) { return '<button class="vs-facet" data-vs-f="room" data-vs-v="' + x[0][0] + '" aria-pressed="' +
        (VS.active.room === x[0][0]) + '">' + esc(x[0][1]) + '<u>' + x[1] + '</u></button>'; });
    var mts = I.mats.map(function (m, i) { return [m, countArr('m', i)]; })
      .filter(function (x) { return x[1]; }).sort(function (a, b) { return b[1] - a[1]; }).slice(0, 7)
      .map(function (x) { return '<button class="vs-facet" data-vs-f="material" data-vs-v="' + x[0][0] + '" aria-pressed="' +
        (VS.active.material === x[0][0]) + '">' + esc(x[0][1]) + '<u>' + x[1] + '</u></button>'; });
    if (window.matchMedia('(max-width:700px)').matches) {
      // phones: one scrollable row of colour swatches. The full facet stack costs a
      // whole screen before any product appears, and colour is the refinement that matters.
      var swatches = I.colors.map(function (c, i) { return [c, countArr('c', i)]; })
        .filter(function (x) { return x[1]; }).sort(function (a, b) { return b[1] - a[1]; }).slice(0, 12)
        .map(function (x) { return '<button class="vs-sw" data-vs-f="color" data-vs-v="' + x[0][0] + '" aria-pressed="' +
          (VS.active.color === x[0][0]) + '"><i style="background:' + x[0][2] + '"></i>' +
          esc(x[0][1]) + '<small>' + x[1] + '</small></button>'; });
      if (swatches.length < 2) { railEl.hidden = true; root.querySelector('.vs-body').classList.add('vs-norail'); return; }
      railEl.innerHTML = '<div class="vs-swline">' + swatches.join('') + '</div>';
      return;
    }
    railEl.innerHTML = sec('Colour', cols) + sec('Type', tys) + sec('Room', rms) + sec('Material', mts);
    if (!railEl.innerHTML) { railEl.hidden = true; root.querySelector('.vs-body').classList.add('vs-norail'); }
  }
  function zero(f, raw) {
    var I = VS.index, alt = '';
    if (f.unstocked.length) {
      var row = I.unstocked.filter(function (r) { return r[0] === f.unstocked[0]; })[0];
      if (row) {
        var target = hex2rgb(row[1]);
        var near = I.colors.map(function (c, i) {
          return { c: c, d: dist(hex2rgb(c[2]), target), n: VS.products.filter(function (p) { return p.c.indexOf(i) > -1; }).length };
        }).filter(function (x) { return x.n; }).sort(function (a, b) { return a.d - b.d; }).slice(0, 4);
        alt = '<div class="vs-alt"><h3>Closest colours we do carry</h3><div class="vs-swrow">' +
          near.map(function (x) { return '<button class="vs-sw" data-vs-pick="' + x.c[0] + '"><i style="background:' +
            x.c[2] + '"></i>' + esc(x.c[1]) + '<small>' + x.n + '</small></button>'; }).join('') + '</div></div>';
      }
    }
    return '<div class="vs-zero"><h2>No ' + esc(raw.trim()) + '.</h2>' +
      '<p>' + (f.unstocked.length ? 'We don&rsquo;t stock ' + esc(f.unstocked[0]) + '.' : 'Nothing matches every part of that.') +
      '</p>' + alt +
      '<div class="vs-help"><a class="vs-btn vs-btn--p" href="/pages/interior-design-service">Ask a designer &mdash; free</a>' +
      '<a class="vs-btn" href="/pages/kapolei-hawaii-furniture-showroom">Visit the Kapolei showroom</a>' +
      '<a class="vs-btn" href="/search?q=' + encodeURIComponent(raw) + '">See all Shopify results</a></div></div>';
  }
  function pre() {
    var I = VS.index;
    var top = I.colors.map(function (c, i) { return [c, VS.products.filter(function (p) { return p.c.indexOf(i) > -1; }).length]; })
      .filter(function (x) { return x[1] > 3; }).sort(function (a, b) { return b[1] - a[1]; }).slice(0, 9);
    var ex = ['grey sectional under $2,000', 'blue velvet chair', 'small sofa for a lanai',
              'sofa with washable covers', 'light wood dining table', 'modular sofa in sand'];
    return '<div class="vs-pre">' +
      '<div><h3>Try a sentence</h3><div class="vs-qlist">' + ex.map(function (q) {
        return '<button data-vs-q="' + esc(q) + '">' + esc(q) + '</button>'; }).join('') + '</div></div>' +
      '<div><h3>Shop by colour</h3><div class="vs-swrow">' + top.map(function (x) {
        return '<button class="vs-sw" data-vs-pick="' + x[0][0] + '"><i style="background:' + x[0][2] + '"></i>' +
          esc(x[0][1]) + '<small>' + x[1] + '</small></button>'; }).join('') + '</div></div>' +
      '<div><h3>Shop by room</h3><div class="vs-qlist">' + I.rooms.map(function (r) {
        return '<button data-vs-q="' + esc(r[1].toLowerCase()) + '">' + esc(r[1]) + '</button>'; }).join('') + '</div></div>' +
      '</div>';
  }

  function say(msg) {
    var el = root && root.querySelector('[data-vs-status]');
    if (el) el.textContent = msg;
  }

  /* ---------- run ---------- */
  function run() {
    if (!VS.index) return;
    var raw = input.value;
    root.querySelector('[data-vs-clear]').hidden = !raw;
    var a = VS.active, anyFacet = a.color || a.type || a.room || a.material || a.feature;
    if (!raw.trim() && !anyFacet) { undEl.hidden = true; railEl.hidden = true;
      root.querySelector('.vs-body').classList.add('vs-norail'); resEl.innerHTML = pre(); return; }

    var f = VS.parse(raw), r = VS.search(f);
    understanding(r.f); rail(r.hits);
    if (!r.hits.length) { say('No results for ' + raw.trim()); resEl.innerHTML = zero(r.f, raw); return; }
    var LBL = { room: 'that room', feature: 'that feature', seats: 'the seat count',
                material: 'that material', price: 'that budget', text: 'those words' };
    var notes = [];
    if (r.relaxed.length) notes.push('Nothing matched ' + r.relaxed.map(function (k) { return LBL[k] || k; }).join(' or ') +
      ' exactly, so we widened that one. Everything else still holds.');
    if (r.dead && r.dead.length) notes.push('We don\u2019t recognise \u201c' + r.dead.map(esc).join('\u201d, \u201c') +
      '\u201d, so ' + (r.dead.length > 1 ? 'those were' : 'that was') + ' ignored.');
    var relax = notes.length ? '<div class="vs-relax">' + notes.join(' ') + '</div>' : '';
    var shown = r.hits.slice(0, 36);
    say(r.hits.length + (r.hits.length === 1 ? ' piece' : ' pieces') + ' found');
    resEl.innerHTML = '<div class="vs-top"><span class="vs-n"><b>' + r.hits.length + '</b> ' +
      (r.hits.length === 1 ? 'piece' : 'pieces') + '</span>' +
      '<a class="vs-all" href="/search?q=' + encodeURIComponent(raw) + '">See all results &rarr;</a></div>' +
      relax + '<div class="vs-grid">' + shown.map(function (p) { return card(p, r.f.colors); }).join('') + '</div>';
  }

  /* ---------- open / close ---------- */
  var lastFocus = null, restoring = false;
  function isOpen() { return root && !root.hasAttribute('hidden'); }
  function open(seed) {
    if (restoring) return;              // focus restored by close() must not re-open
    if (isOpen()) { if (seed != null) { input.value = seed; run(); } input.focus(); return; }
    // a theme drawer (cart/nav) holds the scroll lock and paints above us — don't fight it
    if (document.documentElement.classList.contains('lock') && !isOpen()) return;
    build();
    lastFocus = document.activeElement;
    root.removeAttribute('hidden');
    document.documentElement.style.overflow = 'hidden';
    setInert(true);
    if (seed != null) input.value = seed;
    VS.load().then(function () { run(); }).catch(function (err) {
      // stale or unreachable index: hand the shopper to Shopify's own search rather than
      // showing prices and stock we cannot vouch for
      var q = encodeURIComponent(input.value || '');
      resEl.innerHTML = '<div class="vs-zero"><h2>Taking you to full search</h2>' +
        '<p>' + (err && err.stale ? 'Our quick results are being refreshed.'
                                  : 'Quick results are unavailable right now.') + '</p>' +
        '<div class="vs-help"><a class="vs-btn vs-btn--p" href="/search?q=' + q + '">Search all products</a></div></div>';
      if (q) setTimeout(function () { location.href = '/search?q=' + q; }, 1200);
    });
    setTimeout(function () { input.focus(); }, 30);
  }
  function close() {
    if (!root) return;
    root.setAttribute('hidden', '');
    document.documentElement.style.overflow = '';
    setInert(false);
    if (lastFocus && lastFocus.focus) {
      restoring = true;
      try { lastFocus.focus(); } catch (e) {}
      // release on the next frame, after the focus event has been delivered
      requestAnimationFrame(function () { restoring = false; });
    }
  }
  window.ValyouSearchUI = { open: open, close: close };

  /* ---------- header wiring ---------- */
  var wired = false;
  function wire() {
    if (wired) return; wired = true;
    fillMegaColours();
    document.addEventListener('click', function (e) {
      var t = e.target.closest('[data-valyou-search-open]');
      if (!t) return;
      e.preventDefault(); e.stopPropagation();
      open(t.getAttribute('data-seed') || '');
    }, true);
    // delegated, so a theme-editor re-render of the header section keeps search working
    document.addEventListener('submit', function (e) {
      var f = e.target.closest && e.target.closest('[data-valyou-search-form]');
      if (!f) return;
      e.preventDefault();
      var i = f.querySelector('input[name=q]');
      open(i ? i.value : '');
    });
    document.addEventListener('focusin', function (e) {
      var i = e.target.closest && e.target.closest('[data-valyou-search-form] input[name=q]');
      if (i) open(i.value);
    });
    // same guard on the header field, in the capture phase so we beat the theme's handler
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter') return;
      var i = e.target.closest && e.target.closest('[data-valyou-search-form] input[name=q]');
      if (!i) return;
      e.preventDefault(); e.stopPropagation();
      open(i.value);
    }, true);
    // warm the index when the browser is idle, so the first open is instant
    var warm = function () { VS.load().catch(function () {}); };
    if ('requestIdleCallback' in window) requestIdleCallback(warm, { timeout: 4000 });
    else setTimeout(warm, 2500);
  }
  /* ---------- mega panel colour rows ----------
     Driven by the same index as search, so the counts are real and clicking a
     swatch opens the overlay already filtered — no separate colour taxonomy. */
  function fillMegaColours() {
    var panels = document.querySelectorAll('[data-vs-mega]');
    if (!panels.length) return;
    VS.load().then(function () {
      var I = VS.index;
      // which product types plausibly belong to each top-level menu entry
      var SCOPE = {
        'furniture': null,
        'living room': ['sofa','sectional','daybed','recliner','accentchair','ottoman','coffeetable','sidetable','mediatable'],
        'bedroom': ['bed','nightstand','dresser','vanity','bench'],
        'dining': ['diningtable','chair','stool','sideboard','bench'],
        'decor': ['lamp','mirror','accessory'],
        'sale': null, 'new': null
      };
      Array.prototype.forEach.call(panels, function (panel) {
        var cat = (panel.getAttribute('data-vs-mega') || '').toLowerCase();
        var scope = null;
        Object.keys(SCOPE).forEach(function (k) { if (cat.indexOf(k) > -1 && SCOPE[k]) scope = SCOPE[k]; });
        var pool = VS.products;
        if (scope) {
          var idxs = scope.map(function (k) { return kidx(I.types, k); }).filter(function (n) { return n > -1; });
          pool = pool.filter(function (p) { return idxs.indexOf(p.ty) > -1; });
        }
        var rows = I.colors.map(function (c, i) {
          return [c, pool.filter(function (p) { return p.c.indexOf(i) > -1; }).length];
        }).filter(function (x) { return x[1] > 1; })
          .sort(function (a, b) { return b[1] - a[1]; }).slice(0, 8);
        if (rows.length < 3) return;
        var box = panel.querySelector('[data-vs-mega-colours]');
        var wrap = box && box.querySelector('.vs-mega__swatches');
        if (!wrap) return;
        wrap.innerHTML = rows.map(function (x) {
          return '<button type="button" class="vs-mega__sw" data-vs-megapick="' + esc(x[0][0]) + '">' +
            '<i style="background:' + x[0][2] + '"></i>' + esc(x[0][1]) + '<small>' + x[1] + '</small></button>';
        }).join('');
        box.hidden = false;
      });
    }).catch(function () {});
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-vs-megapick]');
    if (!b) return;
    e.preventDefault();
    var d = b.closest('details'); if (d) d.removeAttribute('open');
    var a = VS.active; a.color = a.type = a.room = a.material = a.feature = null;
    a.color = b.getAttribute('data-vs-megapick');
    open('');
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', wire);
  else wire();
  // the theme editor re-renders the header section on every setting change
  document.addEventListener('shopify:section:load', function () { fillMegaColours(); });
})();
